module.exports = __webpack_public_path__ + "img/버팀목전세자금대출.2471645e.png";